module.exports = __webpack_public_path__ + "img/sg-logo.c67ea018.png";